export default "__VITE_ASSET__DF3ENcMB__"